import { gql } from '@common/hooks';

export const SubmittalPacketChangeRequestMutation = gql`
  mutation CreateOfferChangeRequest(
    $changeRequestableId: ID!
    $changeRequestType: ChangeRequestType!
    $input: CreateOfferChangeRequestInput!
  ) {
    createOfferChangeRequest(
      changeRequestableId: $changeRequestableId
      changeRequestType: $changeRequestType
      input: $input
    ) {
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;
